<template>
  <Container type="card-full">
    <div slot="header">
      <el-button-group>
        <el-button @click="btnClick('SAV')" :loading="btnLoading">保存</el-button>
        <!-- <el-button @click="btnClick('EXT')" :loading="btnLoading">关闭</el-button> -->
      </el-button-group>
    </div>
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="表名" prop="">
            <el-input v-model="form.tablecode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="表说明" prop="">
            <el-input v-model="form.tablename" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vggrid ref="xGrid" :list="list" flexname="" :cols="cols" :showfooter="false"
            :resizable="true" :showPage="false" activeCell="tablekeycode" :needBlackRow="true"></vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  export default {
    name: 'tablekey',
    data () {
      return {
        list: [],
        btnLoading: false,
        cols: [
          { type: 'index', title: '顺序号',calculExpr:'', width: 80,editRender:{} },
          { field: 'tablekeycode', title: '键值',calculExpr:'', triggercol: 0,addNewRowFlg: true, editRender: { name: 'ElInput'}},
          { field: 'tablekeytype', title: '键类型',syscode: 'tablekeytype',calculExpr:'', triggercol: 0, addNewRowFlg: false, editRender: { name: 'select',options: []}},
          { field: 'tablekeys', title: '键数',calculExpr:'', triggercol: 0, addNewRowFlg: false,editRender: { name: 'input'} },
          { field: 'tablekey1', title: '键1',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey2', title: '键2',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey3', title: '键3',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey4', title: '键4',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey5', title: '键5',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey6', title: '键6',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey7', title: '键7',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey8', title: '键8',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey9', title: '键9',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'tablekey10', title: '键10',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}}
        ],
        form: this.$route.params.form,
        tablekey: {}
      }
    },
    created () {
      this.$on('SAV', () => this.savTablekey())
      this.$on('DEL', () => this.delTablekey())
      this.$on('EXT', () => this.close())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getTablekeyList()
    },
    mounted () {

    },
    components: {vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async delTablekey () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/field/delTablekey',
            method: "post",
            data: this.field
          })
          if (data.issuccess===1) {
            this.getTablekeyList()
            this.$message.success(data.msg)
          }
        })
      },
      checkIsChg() {
        let detail = this.$refs.xGrid.$refs.xGrid.getRecordset()
        if (detail.insertRecords.length===0 && detail.updateRecords.length === 0 && detail.removeRecords.length ===0) {
          return false
        } else {
          return true
        }
      },
      async savTablekey () {
        if (!this.checkIsChg()) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let detail = this.$refs.xGrid.$refs.xGrid.getRecordset()
        let model = {
          head: this.form,
          detail: detail
        }
        let data = await request({
          url: '/kfgl/tablekey/save',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.getTablekeyList()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getTablekeyList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/tablekey/getTablekeyList',
          params: {tableid: this.form.tableid}
        })
        this.list = res.list
        this.$refs.xGrid.$refs.xGrid.insertAt({},-1)
          .then(({ row }) => this.$refs.xGrid.$refs.xGrid.setActiveCell(row, 'tablekeycode'))
        this.loading = false
      },
      close () {
        if (this.checkIsChg()) {
          this.$confirm('数据有修改，是否不保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'tableIndex'})
          })
        } else {
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'tableIndex'})
        }
      }
    }
  }
</script>
<style lang="scss">

</style>
